
import Vue from 'vue'
/**
 * 金额格式化
 * 1234567890.01  =>  1,234,567,890.01
 * eg:{{1234567890.01 | wq_capitalize('RMB')}}   => ￥1,234,567,890.01
 * **/
Vue.filter('wq_mFormat', (value,dw) => {
  //dw 货币单位预留字段
  if(!dw) dw = '';
  if(value === null || value === undefined || value === '') value = 0;
  value = value.toString();
  if(!value.split(".")[1]){
    return dw + " " +  value.replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,') + '.00';
  }else if(value.split(".")[1].length == 1){
    return dw + " " +  value.replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,') + '0';
  }else if(value.split(".")[1].length == 2){
    return dw + " " +  value.replace(/\d{1,3}(?=(\d{3})+(?:\.\d{1,2})?$)/g, '$&,');
  }
});


/**
 * 日期格式化
 * eg:{{data | wq_capitalize('yyyy-MM-dd hh:mm')}}
 *  **/
Vue.filter('wq_capitalize', (value, f) => {
  if(!value) return '';
  var elem = new Date(value);
  var o ={
    "M+" : elem.getMonth()+1, //月
    "d+" : elem.getDate(),    //d日
    "h+" : elem.getHours(),   //时
    "m+" : elem.getMinutes(), //分
    "s+" : elem.getSeconds(), //秒
    "q+" : Math.floor((elem.getMonth()+3)/3),
    "S" : elem.getMilliseconds()
  }
  if(/(y+)/.test(f)) f=f.replace(RegExp.$1,(elem.getFullYear()+"").substr(4 - RegExp.$1.length));
  for(var k in o)
    if(new RegExp("("+ k +")").test(f))f = f.replace(RegExp.$1,RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));return f
});


/**
 * 状态过滤
 * eg:{{data | statusTostr}}
 *  **/
Vue.filter('statusTostr', (value) => {
  if(!value) return '';
  var str = ''
  if(value === 'Auditing'){
    str = '正在审核中...'
  }else if(value === 'Approve'){
    str = '已审核通过'
  }else if(value === 'UnApprove'){
    str = '审核未通过'
  }
  return str
});

/**
 * 日期格式化并计算时长
 * eg:{{data | wq_capitalize('yyyy-MM-dd hh:mm')}}
 *  **/
Vue.filter('duration', (times) => {
  if(!times) return '';
  // var timer = setInterval(function(){
  //   var leftTime = (new Date(times)) - (new Date()); //计算剩余的毫秒数
  //   var days = parseInt(leftTime / 1000 / 60 / 60 / 24 , 10); //计算剩余的天数
  //   var hours = parseInt(leftTime / 1000 / 60 / 60 % 24 , 10); //计算剩余的小时
  //   var minutes = parseInt(leftTime / 1000 / 60 % 60, 10);//计算剩余的分钟
  //   var seconds = parseInt(leftTime / 1000 % 60, 10);//计算剩余的秒数
  //   var timehtml='剩余'+days+'天'+hours+'小时' + minutes+'分'+seconds+'秒';
  //   return timehtml
  // },1000);
    var nowTime = new Date()
    var leftTime = (new Date(times)) - nowTime;
    var days = parseInt(leftTime / 1000 / 60 / 60 / 24 , 10); //计算剩余的天数
    var hours = parseInt(leftTime / 1000 / 60 / 60 % 24 , 10); //计算剩余的小时
    var minutes = parseInt(leftTime / 1000 / 60 % 60, 10);//计算剩余的分钟
    var seconds = parseInt(leftTime / 1000 % 60, 10);//计算剩余的秒数
    var timehtml='剩余'+days+'天'+hours+'小时' + minutes+'分'+seconds+'秒';
    return timehtml;
});
/**
 * 数组处理
 * eg:{{data | wq_capitalize('yyyy-MM-dd hh:mm')}}
 *  **/
Vue.filter('arrayTo', (value, f) => {
  if(!value) return false;
  var arrStr = ''
  value.forEach(function (c) {
    arrStr += c;
  })
  return arrStr
});
/**
 * 产品来源
 * eg:
 *  **/
Vue.filter('sourceTypeStr', (value) => {
  if(!value) return false;
  if(value =='SelfBuild'){
    return '自建产品'
  }else if(value == 'Collected'){
    return '采集产品'
  }
});

/**
 * 商品状态
 * eg:
 *  **/
Vue.filter('publishedStatus', (value) => {
  if(!value) return '';
  if(value =='Null'){
    return '无商品状态'
  }else if(value == 'Shelved'){
    return '已上架'
  }else if(value == 'UnShelved'){
    return '已下架'
  }else if(value == 'Auditing'){
    return '审核中'
  }else if(value == 'PlatformDeleted'){
    return '平台已删除'
  }else if(value == 'Refuse'){
    return '审核失败'
  }
});

/**
 * 超出三个点显示
 * eg:中文8个字英文16个字
 *
 *  **/
Vue.filter('ellipsisEight', (value) => {
  // var reg = /^[\\u4E00-\\u9FA5]+$/;
  // if (!reg.test(value)){
  if(escape(value).indexOf("%u")<0){
    // console.log( "不全是中文" );
    if(value.length > 16){
      return value.substring(0,15)+'...'
    }else{
      return value
    }
  } else {
    // console.log( "全是中文" );
    if(value.length > 8){
      return value.substring(0,8)+'...'
    }else{
      return value
    }
  }
});

/**
 * 根据国家代码显示国家名称
 * eg:AZ——"阿塞拜疆"
 *
 *  **/
Vue.filter('alpha2CodeToName', (value,arr) => {
  if(!value) return '';
  for (let i = 0; i < arr.length; i++) {
    if(arr[i].alpha2Code == value){
      return arr[i].cnName
    }
  }
});
/**
 * 预报状态
 * eg:
 *  **/
Vue.filter('noticeStatusStr', (value) => {
  if(!value) return '';
  if(value =='FetchLogisticOrderNoFailure'){
    return '预报失败'
  }else if(value == 'UnASN'){
    return '待预报'
  }
});

export default {}



// WEBPACK FOOTER //
// ./src/public/filters.js